var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globalG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7489 6C15.7489 8.07107 14.0699 9.75 11.9989 9.75C9.9278 9.75 8.24886 8.07107 8.24886 6C8.24886 3.92893 9.9278 2.25 11.9989 2.25C14.0699 2.25 15.7489 3.92893 15.7489 6Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.1182C4.57031 16.0369 7.90074 12.75 11.9989 12.75C16.0971 12.75 19.4276 16.0371 19.4977 20.1185C17.2149 21.166 14.6753 21.75 11.9992 21.75C9.32286 21.75 6.78296 21.1659 4.5 20.1182Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.eb65601eb1959b158e03d7db9ac6de2f.svg";
export { ForwardRef as ReactComponent };